/* Comportamiento del encabezado al hacer scroll.
 *
 * En el homepage (donde hay hero con video):
 *   · Hasta arriba          → transparente sobre el video
 *   · Al bajar un poco      → se pega arriba con fondo blanco
 *   · Al seguir bajando     → se esconde para no estorbar
 *   · Al subir              → reaparece de inmediato
 *
 * En las demás páginas hace lo mismo, pero nunca es transparente.
 *
 * Todo se hace poniendo y quitando clases; el CSS hace el resto.
 */
(function () {
  'use strict';

  const header = document.querySelector('[data-header]');
  if (!header) return;

  const announcement = document.querySelector('.announcement-bar');
  const countdownBar = document.querySelector('.cdbar');
  const hero = document.querySelector('.hero--media');

  // El header flota bajo la barra de anuncios y/o el temporizador: hay que
  // saber cuánto miden juntos (el temporizador arranca oculto y se muestra
  // por JS, así que se remide en cada tick — ver measureHeader más abajo).
  function measureAnnouncement() {
    const h = (announcement ? announcement.offsetHeight : 0) + (countdownBar ? countdownBar.offsetHeight : 0);
    document.documentElement.style.setProperty('--announcement-h', h + 'px');
    return h;
  }

  // Otras secciones (ej. la foto fija de la página de producto) necesitan
  // saber cuánto mide el header para no quedar tapadas cuando se pega arriba.
  function measureHeader() {
    const h = header.offsetHeight;
    document.documentElement.style.setProperty('--header-h', h + 'px');
    return h;
  }

  let announcementH = measureAnnouncement();
  let headerH = measureHeader();

  // Desde dónde se pega: pasando la barra de anuncios, o el hero si lo hay.
  function stickPoint() {
    return announcementH + 40;
  }

  // Desde dónde puede esconderse: ya lejos del inicio, para que no brinque.
  function hidePoint() {
    return headerH + announcementH + 120;
  }

  let lastY = window.scrollY;
  let ticking = false;

  function onScroll() {
    const y = window.scrollY;

    // Con el menú móvil, el carrito o el buscador abiertos, el header se queda quieto
    const drawerOpen =
      document.querySelector('.mdrawer[open]') ||
      document.querySelector('.drawer.is-open') ||
      header.classList.contains('is-searching');

    if (drawerOpen) {
      ticking = false;
      return;
    }

    if (y > stickPoint()) {
      header.classList.add('is-stuck');
    } else {
      header.classList.remove('is-stuck', 'is-hidden');
      ticking = false;
      lastY = y;
      return;
    }

    const goingDown = y > lastY;
    // 4px de tolerancia: el scroll por inercia del trackpad tiembla y haría parpadear
    const moved = Math.abs(y - lastY) > 4;

    if (moved) {
      if (goingDown && y > hidePoint()) {
        header.classList.add('is-hidden');
      } else if (!goingDown) {
        header.classList.remove('is-hidden');
      }
      lastY = y;
    }

    ticking = false;
  }

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      // requestAnimationFrame: se calcula una vez por cuadro, no en cada píxel de scroll
      window.requestAnimationFrame(onScroll);
    },
    { passive: true }
  );

  window.addEventListener('resize', () => {
    announcementH = measureAnnouncement();
    headerH = measureHeader();
  });

  // Al abrir el menú móvil el header debe verse normal, no transparente
  const drawer = header.querySelector('.mdrawer');
  if (drawer) {
    drawer.addEventListener('toggle', () => {
      document.body.style.overflow = drawer.open ? 'hidden' : '';
    });

    // La "X" es un <span>, no el <summary>: por sí sola no cierra el <details>
    const closeBtn = drawer.querySelector('.mdrawer__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        drawer.open = false;
      });
    }
  }

  // Si la página carga ya con scroll (al recargar a medio camino), pintar el estado correcto
  onScroll();
})();
